<template>
<div class="nothing">
  <div class="img"></div>
  <slot></slot>
</div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.nothing
  text-align: center
  font-size: 0
  commonBgColor(#1f2330, #FFFFFF)
  padding: 160px 0
  .img
    display: inline-block
    vertical-align: top
    width: 180px
    height: 92px
    commonBgImg('~pic/no_pic.png', '~pic/no_pic_w.png')
    background-size: 100% !important
    background-repeat: no-repeat !important
  p
    commonColor(#797b83, #333333)
    font-size: 14px
    margin-top: 16px
    line-height: 24px
    a
      color: rgba(250, 122, 80, 1)
      cursor: pointer
</style>
